import { Modal } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import React, { useContext } from "react";
import { Spinner, Container, Alert, Col } from "reactstrap";
export interface IProps {
    title: string;
    isOpen : boolean;
    message: string;
    size?: string;
    toggle: () => void;
    }
const LoaderModal : React.FC<IProps> = (
    {
      
        title,
        isOpen,
        message,
        toggle,
        size
    }
) => {
    const rootStore = useContext(RootStoreContext);
    const { theme } = rootStore.commonStore;
    return(<>
 <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={toggle}
      size={size ? size : "lg"}
    >
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          {title}
        </h5>
      </div>
      <div className="modal-body">
      <Container className="themed-container" fluid>
      <Col sm={12}>
        <Alert color={theme ? theme.loaderColor : "primary"} className="text-center">
          <div className="mb-2">{message}...</div>
          <Spinner color="light" />
        </Alert>
      </Col>
    </Container>
          
          </div>
    </Modal>
    </>)
}

export default LoaderModal